<div class="d-inline-flex position-relative" *ngIf="isAvailable && hasDropdownItems">
	<button
		type="button"
		class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap ci-docs-dropdown__btn"
		[class.ci-docs-dropdown__btn--open]="menuOpen"
		[disabled]="loading || !src"
		(click)="toggleMenu($event)"
	>
		<i class="fa-regular fa-file-pdf"></i>
		<span>{{ buttonLabel }}</span>
		<i class="fa-regular" [ngClass]="menuOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
	</button>
	<div
		class="dropdown-menu show position-absolute top-100 start-0 mt-1 rounded-3 p-2 d-flex flex-column gap-1 ci-docs-menu"
		*ngIf="menuOpen"
		(click)="$event.stopPropagation()"
	>
		<button
			type="button"
			class="dropdown-item d-flex align-items-center gap-2 rounded ci-docs-menu__item"
			[class.ci-docs-menu__item--active]="openSubmenu === 'versions'"
			(mouseenter)="setOpenSubmenu('versions')"
			(click)="setOpenSubmenu('versions')"
		>
			<i class="fa-regular fa-file-pdf flex-shrink-0"></i>
			<span>PDF Report Versions</span>
			<i class="fa-regular fa-chevron-right ms-auto flex-shrink-0"></i>
		</button>
		<button
			type="button"
			class="dropdown-item d-flex align-items-center gap-2 rounded ci-docs-menu__item"
			[class.ci-docs-menu__item--active]="openSubmenu === 'attachments'"
			(mouseenter)="setOpenSubmenu('attachments')"
			(click)="setOpenSubmenu('attachments')"
		>
			<i class="fa-regular fa-paperclip flex-shrink-0"></i>
			<span>Attachments</span>
			<i class="fa-regular fa-chevron-right ms-auto flex-shrink-0"></i>
		</button>

		<div
			class="dropdown-menu show position-absolute top-0 start-100 ms-1 rounded-3 p-2 ci-docs-menu__submenu"
			*ngIf="openSubmenu === 'versions'"
		>
			<div class="px-2 py-1 text-uppercase ci-docs-menu__header">
				{{ pdfVersionCount }} {{ pdfVersionCount === 1 ? 'version' : 'versions' }}
			</div>
			<button
				type="button"
				class="dropdown-item d-flex align-items-center gap-2 rounded ci-docs-menu__file"
				*ngFor="let item of pdfVersionItems"
				(click)="onSelectItem(item)"
			>
				<i class="fa-regular fa-file-arrow-down flex-shrink-0"></i>
				<span>{{ item.label }}</span>
				<span *ngIf="item.isCurrent" class="ms-auto text-uppercase flex-shrink-0 ci-docs-menu__badge">
					Current
				</span>
			</button>
		</div>

		<div
			class="dropdown-menu show position-absolute top-0 start-100 ms-1 rounded-3 p-2 ci-docs-menu__submenu"
			*ngIf="openSubmenu === 'attachments'"
		>
			<div class="px-2 py-1 text-uppercase ci-docs-menu__header">
				{{ attachmentCount }} {{ attachmentCount === 1 ? 'file' : 'files' }}
			</div>
			<ng-container *ngFor="let item of attachmentItems">
				<div *ngIf="item.type === itemType.LABEL" class="dropdown-item disabled text-muted ci-docs-menu__empty">
					{{ item.label }}
				</div>
				<button
					*ngIf="item.type === itemType.OPTION"
					type="button"
					class="dropdown-item d-flex align-items-center gap-2 rounded ci-docs-menu__file"
					(click)="onSelectItem(item)"
				>
					<i class="fa-regular fa-file-arrow-down flex-shrink-0"></i>
					<span>{{ item.label }}</span>
				</button>
			</ng-container>
		</div>
	</div>
</div>

<button
	*ngIf="isAvailable && !hasDropdownItems"
	type="button"
	class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap"
	[disabled]="loading || !src"
	(click)="onDownloadFile()"
>
	<i class="fa-regular fa-file-pdf"></i>
	<span>{{ buttonLabel }}</span>
</button>
